type AreaOption = {
  value: string;
  translationKey: string;
};

export const AREA_OPTIONS: AreaOption[] = [
  { value: "Entrance area", translationKey: "entranceAreaString" },
  { value: "Exit area", translationKey: "exitAreaString" },
  { value: "Markethall Entrance", translationKey: "markethallEntranceString" },
  {
    value: "Self-serve furniture area",
    translationKey: "selfServeFurnitureAreaString",
  },
  { value: "Showroom Entrance", translationKey: "showroomEntranceString" },
];
import { RoomTypes } from "../constants";
import { TaskLink } from "./taskLink";

export type MainAlternativeProducts = {
  mainProductId1?: string | undefined;
  mainProductId2?: string | undefined;
  mainProductName1?: string | undefined;
  mainProductName2?: string | undefined;
  alternativeProductId1?: string | undefined;
  alternativeProductId2?: string | undefined;
  alternativeProductName1?: string | undefined;
  alternativeProductName2?: string | undefined;
};

export type Media = {
  createdAt: string;
  updatedAt: string;
  id: string;
  storeId: string;
  name: string;
  active: "ACTIVE" | "INACTIVE";
  nbrArticles: number;
  pieces?: number;
  mediaType: string;
  parentMediaId?: string;
  mainImageUrl?: string;
  mainImageRotation?: number;
} & MainAlternativeProducts;

export type StyleGroup = { styleGroup?: string };

export type HfLtp = { hfLtp?: string };

export type Pricing = { pricing?: string };

export type LivingSituation = { livingSituation?: string };

type Laha = { laha?: string };

type LivingConditions = { livingConditions?: string };

export type AreaHfb = { areaHfb?: string };

export type MainMessage = { mainMessage?: string };

export type SquareMeters = { squareMeters?: number };

export type RangeDescription = { rangeDescription?: string };

export type ProductRange = { productRange?: string };

export type FirstGrouping = { firstGrouping?: string | undefined };

export type SecondGrouping = { secondGrouping?: string | undefined };

export type ThirdGrouping = { thirdGrouping?: string | undefined };

export type RoomType = { roomType?: RoomTypes | undefined };

type RoomSettings = StyleGroup &
  HfLtp &
  Pricing &
  LivingSituation &
  Laha &
  LivingConditions &
  AreaHfb &
  MainMessage &
  SquareMeters &
  MainAlternativeProducts;

type Room = RoomType & MainAlternativeProducts;

export type RoomSettingsMedia = RoomSettings & Media;
export type RoomMedia = Room & Media;

export type PartialMedia = Partial<Media>;

export type PartialMediaWithId = Pick<Media, "id"> & Partial<Media>;

export type Medias = Media[];

export type MediasResponse = {
  medias: Medias;
  children: Medias;
};

export type MediaResponse = {
  media: Media;
  children: Medias;
  parent: Media;
};

export type MediasAndArticleCountResponse = {
  name: string;
  nbrArticles: number;
  articleId: string;
  groupId: string;
  groupName: string;
  mediaId: string;
  parentMediaName: string;
  parentArticleCombinationNumber?: string;
};

export type AlertResponse = {
  mediaName: string;
  mediaId: string;
  salesStop: number;
  eds: number;
  edsDates: string[];
};

export type Notifications = {
  alerts: AlertResponse[];
  taskLinks: TaskLink[];
  uniqueEdsDates: string[];
};

export type MediaId = {
  mediaId: string;
};
